import { Message, MessageType } from '@/types/globals'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ChatState {
  messages: Message[]
  loading: boolean
}

const initialState: ChatState = {
  loading: false,
  messages: [],
}

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    addMessage: (state, action: PayloadAction<Message>) => {
      state.messages.push({
        ...action.payload,
        disabled: false,
      })
    },
    setMessage: (state, action: PayloadAction<Message[]>) => {
      state.messages = action.payload.map((msg) => ({
        ...msg,
        disabled: msg.disabled ?? false,
      }))
    },
    disableAllMessages: (state) => {
      state.messages.forEach((msg) => {
        if (!msg.disabled) {
          msg.disabled = true
        }
      })
    },

    disableTypedMessages: (
      state,
      action: PayloadAction<{ type?: MessageType }>
    ) => {
      const { type } = action.payload
      state.messages.forEach((msg) => {
        if (!type || msg.type === type) {
          msg.disabled = true
        }
      })
    },
    resetChat: (state) => {
      state.messages = []
    },
    addStream: (state, action) => {
      state.messages.push(action.payload)
    },
    appendStream: (state, action) => {
      state.messages = state.messages.map((item: Message) => {
        if (item.type === action.payload.type) {
          return { ...item, content: item.content + action.payload.content }
        }
        return item
      })
    },
    resetStream: (state) => {
      const index = state.messages.findIndex(
        (m: Message) => m.type === 'stream'
      )
      if (index > -1) {
        const msg = state.messages[index]
        state.messages = [
          ...state.messages.filter((m: Message) => m.type !== 'stream'),
          { ...msg, type: 'idea-text' },
        ]
      }
    },
    resetStream_iterate: (state) => {
      const index = state.messages.findIndex(
        (m: Message) => m.type === 'stream'
      )
  if (index > -1) {
    const msg = state.messages[index]
    state.messages = [
      ...state.messages.filter((m: Message) => m.type !== 'stream'),
      { ...msg, type: 'message' } // or whatever type you want to preserve it as
    ]
  }
},
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    updateMessage: (state, action: PayloadAction<Message>) => {
      state.messages = state.messages.map((m: Message) => {
        if (m?.id === action.payload.id) {
          return { ...action.payload }
        }
        return m
      })
    },
  },
})

export const {
  addMessage,
  setMessage,
  disableAllMessages,
  disableTypedMessages,
  resetChat,
  resetStream_iterate,
  addStream,
  appendStream,
  resetStream,
  setLoading,
  updateMessage,
} = chatSlice.actions
export default chatSlice.reducer
